"use client"
import { selectAgentRole } from "stores/auth/authSlice"
import { useAppSelector } from "stores/hooks"

/**
 * Hook to determine if the current agent user is an agency owner.
 * Returns `true` if `user.agentRole === "OWNER"`.
 */
export function useIsAgentOwner() {
  const agentRole = useAppSelector(selectAgentRole)
  return agentRole === "OWNER"
}
